import React from "react";
import "./Features.css";

function Features() {
  return (
    <>
      <section className="Features">
        <div className="conatiner">
          <div className="img_hodler">
            <img
              src="/assets/images/check_your_fit/features/feature_banner.png"
              className="Features_img"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Features;
